export default {
  state: {
    homeMenu: {
      isVisible: false,
      itens: [
        {
          name: 'Perfil',
          icon: 'user',
          action: '/profile'
        },
        {
          name: 'Pedidos',
          icon: 'shopping-cart',
          action: '/orders'
        },
        {
          name: 'Precisa de ajuda?',
          icon: 'question',
          action: '/help',
          external: true
        }
      ],
      footerItens: [
        {
          name: 'Sair',
          icon: 'sign-out',
          action: 'logOut'
        }
      ]
    }
  },
  mutations: {
    setHomeMenuVisibility (state) {
      state.homeMenu.isVisible = !state.homeMenu.isVisible
    }
  },
  actions: {
    changeHomeMenuVisibility ({ commit }) {
      commit('setHomeMenuVisibility')
    }
  },
  getters: {
    homeMenuList: (state) => state.menuList,
    homeMenu: (state) => state.homeMenu
  }
}
